import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'
export const AnimationContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  img {
    position: absolute;
  }

  .celek {
    left: 0;
    top: 0;
    width: 100%;
  }

  @keyframes allElementsAni {
    0% {
      top: 0%;
    }
    42% {
      top: 0%;
    }
    44% {
      top: 1%;
    }
    46% {
      top: 0%;
    }
    48% {
      top: 0.5%;
    }
    50% {
      top: 0%;
    }
    96% {
      top: 0%;
    }
    98% {
      top: 1%;
    }
    100% {
      top: 0%;
    }
  }

  @keyframes houseAniL {
    0% {
      //top: -3%;
      top: 44%;
    }
    42% {
      //top: -1%;
      top: 47%;
      transform: rotate(2deg) translate(-50%, -50%);
    }
    96% {
      //top: 1%;
      top: 50%;
      transform: rotate(0deg) translate(-50%, -50%);
    }
    100% {
      //top: 1%;
      top: 50%;
    }
  }
  @keyframes houseAniM {
    0% {
      //top: 0.5%;
      top: 34%;
    }
    42% {
      //top: 2.5%;
      top: 37%;
      transform: rotate(2deg) translate(-50%, -50%);
    }
    96% {
      //top: 4.5%;
      top: 40%;
      transform: rotate(0deg) translate(-50%, -50%);
    }
    100% {
      //top: 4.5%;
      top: 40%;
    }
  }
  @keyframes houseAniS {
    0% {
      //top: -3%;
      top: 24%;
    }
    42% {
      //top: -1%;
      top: 27%;
      transform: rotate(2deg) translate(-50%, -50%);
    }
    96% {
      //top: 1%;
      top: 30%;
      transform: rotate(0deg) translate(-50%, -50%);
    }
    100% {
      top: 30%;
    }
  }
`
export const AllElements = styled.div<{ $ani: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  ${(props) =>
    props.$ani &&
    css`
      animation: allElementsAni 1.35s;
    `}
`
export const Background = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
export const House = styled.img<{ $ani: boolean }>`
  width: 56%;
  left: 64%;
  top: 44%;
  transform: translate(-50%, -50%);
  @media (min-aspect-ratio: 16/9) and (min-width: 1025px) {
    width: auto;
    height: 76vh;
  }
  ${mq.parallaxOff} {
    width: 81%;
    top: 34%;
    left: 50%;
    max-width: 90vw;
  }
  @media (max-width: 520px) {
    width: 80%;
    top: 24%;
  }
  ${(props) =>
    props.$ani &&
    css`
      animation: houseAniL 1.4s steps(1, end) forwards;
      ${mq.parallaxOff} {
        animation: houseAniM 1.4s steps(1, end) forwards;
      }
      @media (max-width: 520px) {
        animation: houseAniS 1.4s steps(1, end) forwards;
      }
    `}
`
export const Shadow1 = styled.img<{ $ani: boolean }>`
  width: 34.7%;
  top: 45%;
  left: 0;
  transform: translateY(-100%);
  opacity: 0;
  filter: blur(20px);
  transition: all 0.2s;
  transition-delay: 0.35s;
  ${mq.parallaxOff} {
    width: 42.7%;
    top: 92%;
  }
  @media (max-width: 520px) {
    width: 53.6%;
    top: 72.7%;
  }
  ${(props) =>
    props.$ani &&
    css`
      opacity: 1;
      filter: blur(0);
    `}
`
export const Shadow2 = styled.img<{ $ani: boolean }>`
  width: 33%;
  top: 84.8%;
  left: 0;
  transform: translateY(-100%);
  opacity: 0;
  filter: blur(20px);
  transition: all 0.2s;
  transition-delay: 1.1s;
  ${mq.parallaxOff} {
    left: auto;
    right: 0;
    width: 37.2%;
    top: 93%;
  }
  @media (max-width: 520px) {
    width: 52.4%;
    top: 90.5%;
  }
  ${(props) =>
    props.$ani &&
    css`
      opacity: 1;
      filter: blur(0);
    `}
`
export const Hand1 = styled.img<{ $ani: boolean }>`
  width: 36.5%;
  top: 45%;
  left: -10%;
  transform: rotate(-85deg) translateY(-100%);
  transform-origin: -25% 50%;
  transition: all 0.3s cubic-bezier(0.32, 0, 0.67, 0);
  transition-delay: 0.25s;

  ${mq.parallaxOff} {
    width: 44.5%;
    top: 92%;
  }
  @media (max-width: 520px) {
    width: 54.5%;
    top: 72%;
  }
  ${(props) =>
    props.$ani &&
    css`
      transform: rotate(0deg) translateY(-100%);
      left: 0%;
    `}
`
export const Hand2 = styled.img<{ $ani: boolean }>`
  width: 36.8%;
  top: 84%;
  left: -15%;
  transform: rotate(-85deg) translateY(-100%);
  transform-origin: -25% 50%;
  transition: all 0.3s cubic-bezier(0.32, 0, 0.67, 0);
  transition-delay: 1s;
  ${(props) =>
    props.$ani &&
    css`
      transform: rotate(0deg) translateY(-100%);
      left: 0%;
    `}
  ${mq.parallaxOff} {
    width: 42%;
    top: 92%;
    right: -10%;
    left: auto;
    transform: rotate(85deg);
    transform-origin: 125% 50%;
    ${(props) =>
      props.$ani &&
      css`
        transform: rotate(0deg) translateY(-100%);
        right: 0%;
        left: auto;
      `}
  }
  @media (max-width: 520px) {
    width: 58%;
    top: 90%;
  }
`
